export const theme = {
    token: {
      colorPrimary: "#102c57",
    },
  };
  